module.exports = __webpack_public_path__ + "static/img/12.7923e64.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/12.png
// module id = 6t8L
// module chunks = 0